import { render, staticRenderFns } from "./EditCaption.vue?vue&type=template&id=3797b360"
import script from "./EditCaption.vue?vue&type=script&lang=js"
export * from "./EditCaption.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports